/**
 * LocationChip — header pill showing the active delivery location.
 *
 *   📍 Delivery to · HSR Layout ▾
 *
 * Tap opens <LocationSheet> for editing.
 */
import React from 'react';
import { ChevronDown, MapPin } from 'lucide-react';
import { useLocationStore } from '../../stores/locationStore';
import { css } from '../../design';

export interface LocationChipProps {
  onClick: () => void;
  /** Compact mode used in the two-row mobile header. */
  compact?: boolean;
}

const LocationChip: React.FC<LocationChipProps> = ({ onClick, compact }) => {
  const current = useLocationStore((s) => s.current);
  const label = current?.label || 'Choose your location';
  const eta = current ? 'Delivery in ~12 min' : 'Tap to set location';

  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        color: css.color.text,
        padding: compact ? '4px 8px' : '6px 10px',
        borderRadius: 12,
        maxWidth: compact ? 220 : 320,
        textAlign: 'left',
      }}
      aria-label={`Delivery location: ${label}. Tap to change.`}
    >
      <MapPin size={compact ? 16 : 18} color={css.color.primary} />
      <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1, minWidth: 0 }}>
        <span style={{ fontSize: 11, color: css.color.textMuted, fontWeight: 600, letterSpacing: '0.02em' }}>
          {eta}
        </span>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            fontSize: compact ? 13 : 14,
            fontWeight: 700,
            color: css.color.text,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
          }}
        >
          {label}
          <ChevronDown size={14} />
        </span>
      </span>
    </button>
  );
};

export default LocationChip;

